module.exports = __webpack_public_path__ + "app/principal/modals/modal-error-1MpKdqE-.html";